import { CALENDAR_EVENT_TYPE_OPTIONS } from '../utils/calendar.constants';

const commonFields = ['title', 'description', 'customFields'];
const appointmentRows = [['date', 'time'], ['duration', 'location'], ['attendees'], ['clientId', 'supplierId']];
const categoryDetails = {
  meeting: {
    iconKey: 'overview.calendarMeeting', description: 'Organizza un meeting', priority: true,
    rows: [['date', 'endDate'], ['time', 'duration'], ['location', 'attendees'], ['clientId', 'supplierId']],
    titlePlaceholder: 'Es. Allineamento progetto ACME',
    descriptionPlaceholder: 'Inserisci l’ordine del giorno, i dettagli del meeting o le note utili…',
  },
  deadline: {
    iconKey: 'status.pending', description: 'Pianifica una scadenza', priority: true,
    rows: [['date', 'time'], ['attendees'], ['clientId', 'supplierId']],
    titlePlaceholder: 'Es. Scadenza invio documentazione',
    descriptionPlaceholder: 'Inserisci i dettagli della scadenza, i documenti richiesti o le attività da completare…',
  },
  internal: {
    iconKey: 'overview.calendarMeetings', description: 'Organizza una riunione', priority: true, rows: appointmentRows,
    titlePlaceholder: 'Es. Allineamento progetto ACME',
    descriptionPlaceholder: 'Inserisci l’ordine del giorno, i dettagli della riunione o le note utili…',
  },
  training: {
    iconKey: 'bell', description: 'Aggiungi un promemoria', priority: true, rows: appointmentRows,
    titlePlaceholder: 'Es. Promemoria telefonata di follow-up',
    descriptionPlaceholder: 'Inserisci i dettagli del promemoria, le note utili o le attività da svolgere…',
    locationPlaceholder: 'Es. Google Meet, telefono…',
  },
  incasso: {
    iconKey: 'nav.accounting', description: 'Pianifica un promemoria di incasso',
    rows: [['date', 'amount'], ['clientId']],
    titlePlaceholder: 'Es. Incasso acconto fattura ACME',
    descriptionPlaceholder: 'Inserisci i dettagli dell’incasso, le modalità di pagamento o i riferimenti della fattura…',
  },
  pagamento: {
    iconKey: 'nav.expenses', description: 'Pianifica un promemoria di pagamento',
    rows: [['date', 'amount'], ['attendees', 'supplierId']],
    titlePlaceholder: 'Es. Saldo fattura ACME',
    descriptionPlaceholder: 'Inserisci i dettagli del pagamento, le note di fatturazione o le informazioni sul bonifico…',
  },
};

export const CALENDAR_EVENT_FORMS = Object.fromEntries(
  CALENDAR_EVENT_TYPE_OPTIONS.map(({ value, label }) => [value, {
    type: value, label, ...categoryDetails[value],
    fields: [...commonFields, ...categoryDetails[value].rows.flat(),
      ...(categoryDetails[value].priority ? ['priority'] : []),
      ...(categoryDetails[value].rows.flat().includes('duration') ? ['durationCustom'] : [])],
  }]),
);

export function getCalendarEventForm(type) {
  return CALENDAR_EVENT_FORMS[type] || CALENDAR_EVENT_FORMS.meeting;
}

export function hasCalendarEventField(type, field) {
  return getCalendarEventForm(type).fields.includes(field);
}
